var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEraser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4478 33.2759H24.8505L37.7624 19.8642L37.7631 19.8634C38.3967 19.2013 38.7501 18.3114 38.7501 17.3863C38.7501 16.4612 38.3967 15.5714 37.7631 14.9092L37.7616 14.9076L27.0816 3.88337L27.072 3.87349L27.0617 3.86439L26.8987 3.72065C26.8984 3.72038 26.8981 3.7201 26.8977 3.71983C26.241 3.13287 25.3908 2.82184 24.5178 2.85195C23.6443 2.88207 22.8163 3.25125 22.1995 3.88226L22.1981 3.88377L2.23926 24.5513L2.23788 24.5527C1.60376 25.2169 1.2501 26.1086 1.2501 27.0356C1.2501 27.9626 1.60376 28.8543 2.23788 29.5185L2.23927 29.5199L9.50451 37.0431L9.60771 37.1499H9.75628H33.4478H33.7978V36.7999V33.6259V33.2759H33.4478ZM10.7619 21.2081L24.6338 6.87774L34.8214 17.4284L20.9776 31.7299L10.7619 21.2081ZM11.2002 33.2759L5.17898 27.0352L8.10314 23.9955L17.1235 33.2759H11.2002Z",
    fill: "#4674B9",
    stroke: "#4674B9",
    strokeWidth: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.e1a9a43f04a6505236117735c1a9255d.svg";
export { ForwardRef as ReactComponent };